export const parseDateFormat = (date: string) => {
  let dateObject = new Date(date)
  if (!isNaN(dateObject.getTime())) {
    let formatDate = new Intl.DateTimeFormat('es', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
    return formatDate.format(dateObject)
  }
  return null
}
